import React from 'react';

function PrintRenderSoapNotePopUp({ data }) {
  return (
    <table
      width="734px"
      align="left"
      border={0}
      cellSpacing={0}
      cellPadding={0}
      style={{ marginTop: 15 }}
    >
      <thead>
        <tr width="734px">
          <th
            width="734px"
            style={{ fontWeight: 'bold', fontSize: 14, color: '#000' }}
            align="left"
          >
            SOAP
          </th>
        </tr>
      </thead>
      <tbody>
        <tr width="734px">
          <td
            width="719px"
            style={{
              color: '#000',
              paddingTop: 15,
              paddingLeft: 15,
            }}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: data,
              }}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default PrintRenderSoapNotePopUp;
